// extracted by mini-css-extract-plugin
module.exports = {"component":"LanguageSwitch_component__1iwyt","active":"LanguageSwitch_active__Ld3Zd"};